import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export const productsRoutes = [
  {
    path: "/app/products",
    component: () => import("../../vue-app/pages/PageProductFeed.vue"),
    meta: {
      routeName: window.$_t("PRODUCTS"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_AGENT],
      noPadding: true,
      stylesheet: "latest",
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/products/error/:id",
    component: () => import("../../vue-app/pages/PageProductFeedError.vue"),
    meta: {
      routeName: window.$_t("ERROR_REPORT"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_AGENT],
      noPadding: true,
      stylesheet: "latest",
      skipGlobalLoader: true,
    },
  },
];
